import microAgent from './create-new-relic-agent'

export default microAgent
